import { Database } from "types/supabase";
import { supabaseClient } from "supabase";
import { uploadImage } from "supabase/files";

export type CreateOrganizerParams = {
  name: Database["public"]["Tables"]["organizers"]["Row"]["name"];
  email: Database["public"]["Tables"]["organizers"]["Row"]["email"];
  phone: Database["public"]["Tables"]["organizers"]["Row"]["phone"];
  whatsapp: Database["public"]["Tables"]["organizers"]["Row"]["whatsapp"];
  is_municipality: Database["public"]["Tables"]["organizers"]["Row"]["is_municipality"];
  preferred_language: Database["public"]["Tables"]["organizers"]["Row"]["preferred_language"];
  website: Database["public"]["Tables"]["organizers"]["Row"]["website"];
  description: Database["public"]["Tables"]["organizers"]["Row"]["description"];
  description_pt: Database["public"]["Tables"]["organizers"]["Row"]["description_pt"];
  enable_weekly: Database["public"]["Tables"]["organizers"]["Row"]["enable_weekly"];
  newPicture?: File;
  venueIds?: number[];
};

export const createOrganizer = async ({
  name,
  email,
  phone,
  whatsapp,
  is_municipality,
  preferred_language,
  website,
  description,
  description_pt,
  enable_weekly,
  newPicture,
  venueIds,
}: CreateOrganizerParams) => {
  const createdOrganizer = {
    name,
    email,
    phone,
    preferred_language,
    website,
    description,
    description_pt,
    is_municipality,
    whatsapp,
    enable_weekly,
  };
  const { error, data } = await supabaseClient
    .from("organizers")
    .insert(createdOrganizer)
    .select();

  if (error) {
    throw error;
  }

  let picturePath = null;

  if (newPicture) {
    picturePath = await uploadImage(
      newPicture,
      `${Date.now()}.${newPicture.type.split("/")[1]}`,
      "organizers",
      data[0].uid
    );

    const { error: updateError } = await supabaseClient
      .from("organizers")
      .update({ picture: picturePath })
      .eq("id", data[0].id);

    if (updateError) {
      throw updateError;
    }
  }

  // Create organizer venues relationship if venueIds is provided
  if (venueIds && venueIds.length > 0) {
    const venueRelationships = venueIds.map((venueId) => ({
      organizer_id: data[0].id,
      venue_id: venueId,
    }));

    const { error: insertError } = await supabaseClient
      .from("organizers_venues")
      .insert(venueRelationships);

    if (insertError) {
      throw insertError;
    }
  }

  // Return the id and name of the created organizer for downstream use
  return { id: data[0].id, name: data[0].name };
};
